import { render, staticRenderFns } from "./CommunitySignupStep3.vue?vue&type=template&id=0caa0c50&scoped=true"
import script from "./CommunitySignupStep3.vue?vue&type=script&lang=js"
export * from "./CommunitySignupStep3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caa0c50",
  null
  
)

export default component.exports